module.exports = {
	"Navigation": {
		"live": "Live",
		"stories": "Stories",
		"ambassadors": "Get-to-know"
	},
	"Search": {
		"placeholder": "Find city",
		"errorEmpty": "Please enter a city.",
		"errorNotFound": "The city you were looking for was not found."
	},
	"IndieButton": {
		"line1": "Get",
		"line2": "independent!",
		"line3": ""
	},
	"InfoBox": {
		"sonnenBatterie": "sonnenBatterie",
		"ambassadorSince": "Customer since",
		"capacity": "Capacity",
		"autonomy": "Autonomy",
		"pvSize": "PV size",
		"cta": "Join",
		"ctaAmbassador": "Request an Appointment",
		"disclaimer": "At this customers home you can convince yourself that the sonnenBatterie is suitable for daily use."
	},
	"MasterForm": {
		"title": "Inquire about sonnen products",
		"personalInformation": "Personal information",
		"salutation": "Title",
		"male": "Mr.",
		"female": "Mrs.",
		"firstname": "First Name",
		"lastname": "Last Name",
		"email": "Email",
		"phone": "Phone",
		"energyConsumption": "Energy consumption per year",
		"ecPlaceholder": "kWh",
		"subject": "I'd like…",
		"sonnenBatterie": "to have a sonnenBatterie",
		"sonnenCommunity": "to learn about sonnenCommunity",
		"pvAnlage": "to have information about a PV system",
		"sonnenBotschafter": "to visit a sonnenAmbassador",
		"submit": "Submit",
		"legalNotice": "The data provided will be used exclusively to establish contact with you and to provide you with information about sonnenBatterie. By clicking the submit button you agree to these terms. Fields marked with * are required.",
		"requiredFields": "Fields marked with * are required.",
		"gdprHeadline": "Consent",
		"gdprCheckbox": "I agree to be contacted by e-mail, telephone or post in order to receive relevant information about new products and services from sonnen GmbH and sonnen eServices GmbH (jointly „sonnen”). I am aware that sonnen will forward my contact details to regional partners who will subsequently get in touch for this purpose. My consent can be revoked at any point in time by unsubscribing from the service or by sending an e-mail, fax or letter to the address provided in the contact form on the sonnen website.",
		"successMessage": "Thank you for your interest. Your submission has been received. To complete your request successfully, please click the confirmation link in the e-mail you received.",
		"errorMessage": "Unfortunately your request could not be processed at the moment. Please try again later."
	},
	"Footer": {
		"imprint": "Imprint",
		"privacy": "Privacy Policy"
	}
};


// WEBPACK FOOTER //
// ./src/i18n/en.json